import React from "react";

import styles from './table.module.scss'
import Pagination from '../../../models/Pagination'
import { Button } from '@mui/material';

const TableControl = (props) => {

    let pages = [];

    let initialPage =
        props.pagination?.pageIndex < 5 || props.pagination?.pageCount < 10
            ? 1
            : (props.pagination?.pageCount - props.pagination?.pageIndex >= 5 ? props.pagination?.pageIndex - 4 : props.pagination?.pageCount - 8)



    let finalPage =
        props.pagination?.pageIndex < 5
            ? (props.pagination?.pageCount < 10 ? props.pagination?.pageCount : 9)
            : (props.pagination?.pageCount - props.pagination?.pageIndex >= 5 ? props.pagination?.pageIndex + 4 : props.pagination?.pageCount)


    for (let i = initialPage; i <= finalPage; i++)
        pages.push(<button className={i == props.pagination?.pageIndex ? styles.textButtonSelected : styles.textButton} style={{ marginRight: '5px' }} key={i} onClick={(event) => onChangePage(i, event)} >{' ' + i + ' '}</button>)

    const onChangePage = (param, event) => {
        event.preventDefault();
        let value = 1
        switch (param) {
            case 'First':
                if (props.pagination.pageIndex == 1)
                    return;
                value = 1
                break;
            case 'Previous':
                if (props.pagination.pageIndex == 1)
                    return;
                value = props.pagination.pageIndex - 1
                break;
            case 'Next':
                if (finalPage == 0 || props.pagination.pageIndex == finalPage)
                    return;
                value = props.pagination.pageIndex + 1
                break;
            case 'Last':
                if (finalPage == 0 || props.pagination.pageIndex == finalPage)
                    return;
                value = props.pagination.pageCount
                break;
            default: value = param
        }

        let newPagination = { ...props.pagination };

        newPagination.pageIndex = value;

        props.setPagination(new Pagination().set(newPagination));
    }

    const onChangeSize = (event) => {
        event.preventDefault();

        let newPagination = { ...props.pagination };

        newPagination.pageSize = event.target.value;
        newPagination.pageIndex = 1;

        props.setPagination(newPagination);
    }

    return (
        <div>
            <div className={styles.divTableControlsPageSize}>
                View: <select name="pages" id="pages" value={props.pagination?.pageSize} onChange={onChangeSize}>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                </select>
            </div>
            <div className={styles.pagTableControls}>
                <button className={styles.textButton} id="first" style={{ marginRight: '5px' }} onClick={(event) => onChangePage('First', event)} disabled={props.pagination?.pageIndex == 1}>{"<< First"}</button>
                <button className={styles.textButton} id="previous" style={{ marginRight: '5px' }} onClick={(event) => onChangePage('Previous', event)} disabled={props.pagination?.pageIndex == 1}>{'< Prev'}</button>
                {pages}
                <button className={styles.textButton} id="next" style={{ marginRight: '5px' }} onClick={(event) => onChangePage('Next', event)} disabled={props.pagination?.pageIndex == (props.pagination?.pageCount) || props.pagination?.pageCount == 0}>{'Next >'}</button>
                <button className={styles.textButton} id="last" onClick={(event) => onChangePage('Last', event)} disabled={props.pagination?.pageIndex == (props.pagination?.pageCount) || props.pagination?.pageCount == 0}>{'Last >>'}</button>
            </div>
        </div>
    );
}

export default TableControl;